// removed by extract-text-webpack-plugin
module.exports = {"container":"_30-Kh","content":"_2mCW3","triangleWrapper":"_2fdAw","triangle":"_14pOC","top":"YsVUr"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/tooltip.scss
// module id = 701
// module chunks = 3 4 5 6 7